import { useSelector } from 'react-redux';
import { getActiveLoading } from '../store/loading-status/selectors';
import { getIsVerificationExpired } from '../store/app/selectors';
import { LoadingKey } from '../app-active-loading/LoadingKey';
import { ErrorKey } from '../app-active-error/ErrorKey';
import { getActiveError } from '../store/error/selectors';
export const useIsFramedCentredModalStep = () => {
  const isVerificationExpired = useSelector(getIsVerificationExpired);
  const activeLoading = useSelector(getActiveLoading);
  const isVerificationExpiredRefresh = isVerificationExpired && (!activeLoading || activeLoading !== LoadingKey.SignupRequest);
  const activeError = useSelector(getActiveError);
  if (activeError === ErrorKey.RecaptchaCreationError) {
    return {
      isFramedCentredModalStep: false
    };
  }
  if (isVerificationExpiredRefresh) {
    return {
      isFramedCentredModalStep: true
    };
  }
  return {
    isFramedCentredModalStep: false
  };
};